import { css } from 'react-emotion';

export default css`
	columns: 3;
	font-size: 1rem;

	li {
		box-sizing: border-box;
		margin: 0;
		padding: 0 0.5rem 0 0;
	}

	@media (max-width: 480px) {
		width: 100%;
		columns: 2;
		font-size: 0.9rem;
		line-height: 2;
	}
`
